import * as User from './User';
import * as Contact from './Contact';
export default [
    User,
    Contact
]